// extracted by mini-css-extract-plugin
export default {"cardsContainer":"OtherPlayerInfoComponent_cardsContainer__kBe12","coinsDisplay":"OtherPlayerInfoComponent_coinsDisplay__347LD","coinIcon":"OtherPlayerInfoComponent_coinIcon__mW7-t"};